import { DropdownMenu } from '@buffer-mono/popcorn'

import { useBulkActionsMenuContext } from './BulkActionsMenuContext'

import type { JSX } from 'react'

// Comments bulk-resolve menu entry. Visibility is gated upstream in
// `CommunityFilters`, which only renders this item when the actor can manage at
// least one in-scope channel (the views filter view-only channels out of
// `channelIds`). So this component just renders the menu — no permission check
// here. See CORE-5996.
export function ResolveCommentsItem(): JSX.Element {
  const { requestResolve, postId, channelService } = useBulkActionsMenuContext()
  const isGBP = channelService === 'googlebusiness'
  const itemLabel = isGBP ? 'Reviews' : 'Comments'

  return (
    <DropdownMenu.Group label={itemLabel}>
      <DropdownMenu.Item
        onSelect={(): void => {
          requestResolve('all')
        }}
      >
        Resolve All {itemLabel}
      </DropdownMenu.Item>
      <DropdownMenu.Item
        onSelect={(): void => {
          requestResolve('older-than-month')
        }}
      >
        Resolve Older {itemLabel}
      </DropdownMenu.Item>
      {postId && (
        <DropdownMenu.Item
          onSelect={(): void => {
            requestResolve('post')
          }}
        >
          Resolve {itemLabel} on This Post
        </DropdownMenu.Item>
      )}
    </DropdownMenu.Group>
  )
}
